// extracted by css-extract-rspack-plugin
export default {"container":"IneD6GuNunwdOsmN"};